<div
        (keydown)="onKeydown($event)"
        [attr.aria-label]="ariaLabel"
        aria-roledescription="carousel"
        class="screenshot-carousel"
        tabindex="0"
>
    @if (images.length > 0) {
        <div class="viewport">
            <div [style.transform]="trackTransform" class="track">
                @for (src of images; track src + ':' + $index; let index = $index) {
                    <div class="slide">
                        <img [alt]="altText(index)" [src]="src" loading="lazy"/>
                    </div>
                }
            </div>

            @if (images.length > 1) {
                <button
                        (click)="prev()"
                        [disabled]="!canGoPrev"
                        aria-label="Previous screenshot"
                        class="nav prev"
                        mat-icon-button
                        type="button"
                >
                    <i-tabler name="chevron-left"></i-tabler>
                </button>
                <button
                        (click)="next()"
                        [disabled]="!canGoNext"
                        aria-label="Next screenshot"
                        class="nav next"
                        mat-icon-button
                        type="button"
                >
                    <i-tabler name="chevron-right"></i-tabler>
                </button>
            }
        </div>

        @if (images.length > 1) {
            <div aria-label="Screenshot selection" class="dots" role="tablist">
                @for (_src of images; track 'dot-' + $index; let index = $index) {
                    <button
                            (click)="goTo(index)"
                            [attr.aria-label]="'Go to screenshot ' + (index + 1)"
                            [attr.aria-selected]="index === currentIndex"
                            [class.active]="index === currentIndex"
                            class="dot"
                            role="tab"
                            type="button"
                    ></button>
                }
            </div>
            <div aria-hidden="true" class="counter">{{ currentIndex + 1 }} / {{ images.length }}</div>
        }
    } @else {
        <div class="empty-state">Screenshots coming soon.</div>
    }
</div>

